
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import AsyncTooltip from "@/components/AsyncTooltip/index.vue";
import { searchCustomer } from "@/api/customer";
import {
  getCNList,
  getCNFileList,
  uploadCNFile,
  deleteCNfile,
  updateCNfile,
  downloadExportWord,
  getAudits,
  auditCancel,
  auditHangs,
  uploadClaimTable,
  deleteCNData,
  getCNState,
  getAllAuditState,
  getAllCnState,
  updateRemark,
  manualClearingAmount,
  queryAllocateDetail,
  reUploadClaim,
  getCNReasonTypes, invalidCN, cancelInvalidCN,
} from "@/api/credit-note";
import { getSalesmanList } from "@/api/inquiry";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import checkPermission from "@/utils/permission_btn";

@Component({
  name: "creditNoteManagement",
  components: {
    Pagination,
    AsyncTooltip,
    CNView: () => import("./components/CNView/CNView.vue"),
    CNApply: () => import("./components/CNView/CNApply.vue"),
    Create: () => import("./components/Create.vue"),
  },
})
export default class extends Vue {
  private showOtherBtn = false;
  private isShowMore = false;
  private listLoading = false;
  private showCreate = false;
  private showAnnex = false;
  private showViewCN = false;
  private tableHeight = 400;

  private tableNoteType = "CREDIT_NOTE";

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private resTouch = {} as any;
  public AnnexList = [] as any;
  private GuaQiReason = "";
  private dialogVisible = false;
  private reasonOtherID = 0;
  private showRemarkDialog = false;
  private remarkText = "";
  private remarkRow = {} as any;

  private exportColumns = [
    { label: "单据号码", key: "code" },
    { label: "客人简称", key: "customer" },
    { label: "销售员", key: "seller" },
    { label: "索赔产品数量", key: "claimProductNumber" },
    { label: "采购订单金额", key: "purchaseOrderAmount" },
    { label: "IV金额", key: "ivAmount" },
    { label: "币种", key: "currency" },
    { label: "CN金额", key: "creditNoteAmount" },
    { label: "CN剩余", key: "allocatableAmount" },
    { label: "索赔金额", key: "claimAmount" },
    { label: "索赔抵扣", key: "claimDeduction" },
    { label: "索赔剩余", key: "unDeduction" },
    { label: "索赔损失", key: "claimLoss" },
    { label: "单据类型", key: "type" },
    { label: "原因类型", key: "reasonType" },
    { label: "状态", key: "status" },
    { label: "审核状态", key: "auditStatus" },
    { label: "签发时间", key: "issuedDate" },
    { label: "备注", key: "remark" },
  ];

  public listParam = {
    inquirySheetCode: null,
    customerId: null,
    startTime: null,
    endTime: null,
    sellerId: null,
    status: null,
    type: null,
    time: [],
    reasonType: null,
  };
  public searchForm = [
    {
      label: "请输入客户名称",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "",
      remote: true,
      remote_method: this.searchCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "单据类型",
      prop: "type",
      key: "type",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "销售员",
      prop: "sellerId",
      key: "sellerId",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
    },
    {
      label: "CN号码",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      placeholder: "请输入CN号码",
    },
    {
      label: "生成时间",
      prop: "time",
      key: "time",
      type: "dateTimePicker",
      value: "",
      placeholder: "",
    },
    {
      label: "审核状态",
      prop: "auditStatus",
      key: "auditStatus",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "单据原因类型",
      prop: "reasonType",
      key: "reasonType",
      type: "cascader",
      value: "",
      placeholder: "全部",
      clearable: true,
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
  ];
  private showFileList = false;
  private files: File[] = [];
  private Annex_fa_id = "";
  private Annex_id = "";
  private showCNApply = false;
  private CN_FAITEM = {} as any;
  private claimUploadID = 0;
  private reUploadClaim = false;

  created() {
    if (this.$route.params.code) {
      this.listParam.inquirySheetCode = this.$route.params.code;
      this.searchForm[4].value = this.$route.params.code;
    } else if (this.$route.query.code) {
      this.listParam.inquirySheetCode = this.$route.query.code;
      this.searchForm[4].value = this.$route.query.code as any;
    }
    this.init();
  }

  mounted() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
  }

  activated() {
    this.init();
    this.$nextTick(() => {
      this.updateTableHeight();
    });
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  }

  private updateTableHeight() {
    this.$nextTick(() => {
      const wrap = this.$refs.tableWrap as HTMLElement;
      if (!wrap) {
        return;
      }
      const height = wrap.clientHeight;
      this.tableHeight = height > 200 ? height : 200;
    });
  }

  private checkBtnPermission(codes: string[]) {
    return checkPermission(codes, (this.$route.meta as any)?.buttonCodes);
  }

  private isValueMatch(value: any, values: string) {
    if (value === undefined || value === null || value === "") {
      return false;
    }
    return values.split(",").includes(String(value));
  }

  private formatNumber(val: any) {
    if (val === undefined || val === null || val === "") {
      return "";
    }
    return Number(val).toFixed(2);
  }

  private formatCustomer(row: any) {
    if (row.pcName && row.pcName.length > 0) {
      return `[${row.pcName}]${row.customer}`;
    }
    return row.customer;
  }

  /** 单据管理列：一行最多展示的按钮数，超出放进「更多」 */
  private maxInlineManageActions = 3;

  private isAuditPassed(row: any) {
    return String(row.auditStatus || "").includes("审核通过");
  }

  private getManageActions(row: any) {
    const actions: Array<{ key: string; label: string }> = [];
    if (this.isValueMatch(row.ClaimUpload, "1")) {
      actions.push({ key: "handleClaimUpload", label: "上传索赔清单" });
    }
    if (this.isValueMatch(row.status, "待采购回复")) {
      actions.push({ key: "handleReUploadClaim", label: "重传索赔清单" });
    }
    if (this.isValueMatch(row.auditStatus, "待提交审核,待审核")) {
      actions.push({ key: "handleCNApply", label: "CN申请" });
    }
    actions.push({ key: "handleDownloadCN", label: "下载CN" });
    if (
      this.checkBtnPermission(["manualClearingCn"]) &&
      this.isValueMatch(String(row.canManualClearingAmount), "true")
    ) {
      actions.push({ key: "openManualClearDialog", label: "平账" });
    }
    // if (this.checkBtnPermission(["delete"])) {
    //   actions.push({ key: "handleDeleteCN", label: "删除" });
    // }
    if (this.isValueMatch(row.status, "非索赔单据,待生成索赔单")) {
      actions.push({ key: "handleInvalidCN", label: "作废" });
    }
    if (this.isValueMatch(row.status, "已作废")) {
      actions.push({ key: "handleCancelInvalidCN", label: "取消作废" })
    }
    actions.push({ key: "handleAnnex", label: "附件管理" });
    actions.push({ key: "handleLookReason", label: "查看挂起原因" });
    actions.push({ key: "gotoDocumentFlow", label: "单据流" });
    return actions;
  }

  private getInlineManageActions(row: any) {
    return this.getManageActions(row).slice(0, this.maxInlineManageActions);
  }

  private getOverflowManageActions(row: any) {
    const actions = this.getManageActions(row).slice(this.maxInlineManageActions);
    if (!this.isAuditPassed(row)) {
      actions.unshift({ key: "handleEditCN", label: "编辑" });
    }
    return actions;
  }

  private runManageAction(key: string, row: any) {
    if (!key || key === "handleEditCN") {
      return;
    }
    const fn = (this as any)[key];
    if (typeof fn === "function") {
      fn.call(this, row);
    }
  }

  private handleOverflowAction(action: { key: string }, row: any) {
    if (action.key !== "handleEditCN") {
      return;
    }
    this.handleEditCN(row);
  }

  private async handleDownloadCN(row) {
    await downloadExportWord(row.id);
    this.$notify({
      title: "成功",
      message: "下载成功",
      type: "success",
      duration: 2000,
    });
  }

  private manualClearDialogVisible = false;
  private curCn = {} as any;
  private openManualClearDialog(row) {
    this.curCn = row;
    this.updateManualClearVisible(true);
  }

  /**
   * 更新平账对话框的显示状态。
   * 这里清空备注无论开启或者关闭都清空，没什么问题。
   * @param open
   * @private
   */
  private updateManualClearVisible(open: boolean) {
    this.manualClearDialogVisible = open;
    this.manualClearRemark = "";
  }
  private manualClearRemark = "";
  private manualClearLoading = false;
  private async manualClearAmount() {
    this.manualClearLoading = true;
    try {
      await manualClearingAmount(this.curCn.id, this.manualClearRemark);
      this.updateManualClearVisible(false);
      await this.getList();
    } catch (e) {
      console.error(e);
    } finally {
      this.manualClearLoading = false;
    }
  }

  private addFile(file: File) {
    this.files.push(file);
  }

  private uploadFuJian() {
    this.$refs["uploadPL"]["$refs"]["upload-inner"].handleClick();
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    this.uploadJieKou(formData);
  }

  private async uploadJieKou(formData) {
    await uploadCNFile(this.Annex_id, formData);
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    await this.getCNFileList(this.Annex_fa_id);
  }

  private modelRetrieval() {
    this.$router.push({
      path: "/formUploadTool",
      query: {
        type: "claimForm",
      },
    });
  }

  // CN跳转单据流
  private gotoDocumentFlow(row) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "CREDIT_NOTICE", documentId: row.id },
    });
  }

  private async getAllAuditState() {
    const res: any = await getAllAuditState();
    this.searchForm.find((e) => e.key === "auditStatus").options = res;
  }

  private async getAllCnState() {
    const res: any = await getAllCnState();
    this.searchForm.find((e) => e.key === "type").options = res;
  }

  private async getReasonType() {
    const res: any = await getCNReasonTypes();
    this.searchForm.find((e) => e.key === "reasonType").options = res;
  }

  private async submitGuaQi() {
    if (this.GuaQiReason === "") {
      this.$notify({
        title: "提示",
        message: "请输入挂起原因",
        type: "error",
        duration: 2000,
      });
      return;
    }
    let params = {
      auditHangReason: this.GuaQiReason,
    };
    await auditHangs(this.reasonOtherID, params);
    this.dialogVisible = false;
    this.$notify({
      title: "成功",
      message: "编辑挂起原因成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private handleReason(row) {
    this.reasonOtherID = row.id;
    this.GuaQiReason = row.auditHangReason;
    this.dialogVisible = true;
  }

  private handlePass() {
    this.showViewCN = false;
    this.$notify({
      title: "成功",
      message: "审核成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private handleCloseForCNApply() {
    this.showCNApply = false;
    (this.$refs["CNApply"] as any).init();
  }

  private handleGua() {
    this.showViewCN = false;
    this.$notify({
      title: "成功",
      message: "挂起成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private init() {
    this.getSalesmanList();
    this.getCNState();
    this.searchCustomer();
    this.getList();
    this.getAllAuditState();
    this.getAllCnState();
    this.getReasonType();
  }

  private async getCNState() {
    const res: any = await getCNState();
    this.searchForm[2].options = res;
  }

  private async getList() {
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = true;
    const { total, list }: any = await getCNList(params);
    this.table.total = +total;
    this.table.list = list;
    this.table.list.map((item) => {
      item.ClaimUpload = item.status === "待生成索赔单" ? "1" : "0";
    });
    setTimeout(() => {
      this.listLoading = false;
      this.updateTableHeight();
    }, 0.3 * 1000);
  }

  // 导出
  public handleExport() {
    const headers = this.exportColumns.map((v) => v.label);
    const fieldNames = this.exportColumns.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `CN管理-${new Date()}`
    );
  }

  private async handleDeleteCN(row) {
    this.$confirm("确定要这条删除CN吗", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await deleteCNData(row.id);
        this.$notify({
          title: "成功",
          message: "删除CN成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleInvalidCN(row) {
    this.$confirm("确定要作废这条CN吗", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
        .then(async () => {
          await invalidCN(row.id);
          this.$notify({
            title: "成功",
            message: "CN作废成功",
            type: "success",
            duration: 2000,
          });
          await this.getList();
        })
        .catch((err) => {
          console.error(err);
        });
  }

  private async handleCancelInvalidCN(row) {
    this.$confirm("确定要取消作废这条CN吗", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
        .then(async () => {
          await cancelInvalidCN(row.id);
          this.$notify({
            title: "成功",
            message: "CN取消作废成功",
            type: "success",
            duration: 2000,
          });
          await this.getList();
        })
        .catch((err) => {
          console.error(err);
        });
  }

  public handleCreate() {
    this.selectedItem = {};
    this.showCreate = true;
  }

  public handleEditCN(row) {
    if (this.isAuditPassed(row)) {
      return;
    }
    this.showCreate = false;
    this.selectedItem = Object.assign({}, row);
    this.$nextTick(() => {
      this.showCreate = true;
    });
  }

  private handleSuccess() {
    this.showCreate = false;
    this.getList();
  }

  private handleSuccessCNApply() {
    this.showCNApply = false;
    this.$notify({
      title: "成功",
      message: "申请成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private async handleAnnex(row) {
    this.showAnnex = true;
    this.Annex_fa_id = row.id;
    this.getCNFileList(row.id);
  }

  private async getCNFileList(id) {
    const res: any = await getCNFileList(id);
    this.AnnexList = res;
  }

  private async handleSeeCN(row) {
    this.resTouch = {} as any;
    const res: any = await getAudits(row.id);
    this.CN_FAITEM = row;
    this.tableNoteType = row.type;
    console.log(res);

    this.resTouch = res;
    this.showOtherBtn = false;
    this.showViewCN = true;
    this.$nextTick(() => {
      (this.$refs["CNViews"] as any).getAudits();
    });
  }

  private openRemarkDialog(row) {
    this.remarkRow = row;
    this.remarkText = row.remark || "";
    this.showRemarkDialog = true;
  }

  private async submitRemark() {
    try {
      await updateRemark(this.remarkRow.id, { remark: this.remarkText });
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.showRemarkDialog = false;
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[3].options = res;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.createdTimeStart = time[0];
      rest.createdTimeEnd = time[1];
    }
    if (data.reasonType && data.reasonType.length > 0) {
      rest.reasonType = data.reasonType[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private async handleCancelShenHe(row) {
    this.$confirm("确定取消审核吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditCancel(row.id);
        this.$notify({
          title: "成功",
          message: "取消审核成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async handleShenHe(row) {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    await getAudits(row.id)
      .then((res: any) => {
        this.CN_FAITEM = row;
        this.resTouch = res;
        this.showOtherBtn = true;
        this.showViewCN = true;
        loading.close();
        this.$nextTick(() => {
          (this.$refs["CNViews"] as any).getAudits();
        });
      })
      .catch((err) => {
        console.log(err);
        loading.close();
      });
  }

  private linkClick(row) {
    this.$router.push(
      `/claimDetails?id=${row.id}&customer=${row.customer}&remark=${row.remark}&issuedDate=${row.issuedDate}&code=${row.code}&status=${row.status}&claimAmount=${row.claimAmount}`
    );
  }

  public selectedItem = {} as any;

  private async handleCNApply(row) {
    this.CN_FAITEM = row;
    this.resTouch = {} as any;
    const res: any = await getAudits(row.id);
    this.resTouch = res;
    this.tableNoteType = row.type;
    this.showCNApply = true;
    this.$nextTick(() => {
      (this.$refs["CNApply"] as any).getAudits();
    });
  }

  private handleClaimUpload(row) {
    this.claimUploadID = row.id;
    this.reUploadClaim = false;
    this.$confirm(
      "上传索赔单上传成功之后即可自动生成索赔单，确认上传吗？",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(async () => {
        this.$refs["uploadClaimTable"]["$refs"]["upload-inner"].handleClick();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handleReUploadClaim(row) {
    this.claimUploadID = row.id;
    this.reUploadClaim = true;
    this.$confirm(
      "重新上传会删除掉CN下面所有的索赔单重新生成，确定重新上传吗？",
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(async () => {
        this.$refs["uploadClaimTable"]["$refs"]["upload-inner"].handleClick();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handleUploadClaimTable() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    this.uploadClaimTable(formData);
  }

  private async uploadClaimTable(formData) {
    if (!this.reUploadClaim) {
      await uploadClaimTable(this.claimUploadID, formData);
    } else {
      await reUploadClaim(this.claimUploadID, formData);
    }
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private showLookReason = false;
  public async handleLookReason(row) {
    this.selectedItem = row;
    this.showLookReason = true;
  }

  // 点击是否展示金额
  private showMore() {
    this.isShowMore = !this.isShowMore;
    this.updateTableHeight();
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }

  private filesDownload() {
    if (this.selectedRows.length === 0) {
      this.$message.error("请选择需要下载的附件");
      return;
    }
    this.selectedRows.forEach(async (item) => {
      await window.open(item.url);
    });
  }

  private async deleteFiles() {
    if (this.selectedRows.length === 0) {
      this.$message.error("请选择需要删除的附件");
      return;
    }
    this.$confirm("确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        const ids = this.selectedRows.map((item) => item.id);
        const params = ids.map((id) => `ids=${id}`).join("&");
        await deleteCNfile(params);
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });
        await this.getCNFileList(this.Annex_fa_id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private handleTiHuan(row) {
    this.Annex_id = row.id;
    this.$refs["uploadFJ"]["$refs"]["upload-inner"].handleClick();
  }

  private handleUploadFJ() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    this.uploadFuJianL(formData);
  }

  private async uploadFuJianL(formData) {
    await updateCNfile(this.Annex_id, formData);
    this.$notify({
      title: "成功",
      message: "替换成功",
      type: "success",
      duration: 2000,
    });
    await this.getCNFileList(this.Annex_fa_id);
  }

  private async queryAllocateDetail(id) {
    try {
      const res: any = await queryAllocateDetail(id);
      return res;
    } catch (err) {
      console.error(err);
    }
  }
}
